var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 80,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "147.5%",
    height: "147.5%",
    x: "-23.8%",
    y: "-21.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.164705882 0 0 0 0 0.239215686 0 0 0 0 0.298039216 0 0 0 0.15 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 20)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 77,
    fill: "#FFF",
    stroke: "#6DC926",
    strokeLinejoin: "square",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#6DC926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.617 91.223h-22.77l4.385-11.79c1.123-3.02.125-6.474-2.389-8.278-2.871-2.059-6.743-1.294-8.748 1.725l-12.18 18.343v27.288c0 6.697 5.335 12.127 11.915 12.127h19.41c4.503 0 8.62-2.583 10.642-6.676l5.692-11.515v-15.16c0-3.35-2.665-6.064-5.957-6.064zM74 91.223v36.383"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPending);
export default __webpack_public_path__ + "static/media/icon_pending.d4b97a4aab92730e8399326ab50dc78e.svg";
export { ForwardRef as ReactComponent };